import React, { useEffect, useState } from "react";
import { useAuth } from "../../context/auth";
import { ethers } from "ethers";
import {
  stake6,
  stake6ABI,
  bnbDeod,
  bnbDeodABI,
  oneTimeClaimed,
  oneTimeClaimedABI,
  StakeAddressTwo,
  StakeAbiTwo,
  StakeAddressThree,
  StakeAbiThree,
  StakeAddressFour,
  StakeAbiFour,
  stake5BSC,
  stake5BSCABI,
  stake1,
  stake1ABI,
  stakeAContractAddress,
  stakeAContractABI,
  stakeNv1ContractAddress,
  stakeNv1ContractABI,
} from "../Abi/Content";
import { toast } from "react-toastify";
import axios from "axios";
import UserPageSection from "./Content";
import Loading from "../LoaderPageSection/Loading";
import { motion, AnimatePresence } from "framer-motion";
import proofOfStakeImg from "../../../image/proof-of-stake.png";
import stakedAmountImg from "../../../image/money.png";
import tokenwallet from "../../../image/wallet.png";
import drawalImg from "../../../image/wallets2.png";
import calenderImg from "../../../image/calendar.png";
import totalwithdrawnImg from "../../../image/money-bag.png";
import { getUserLevel } from "../../../utils/userLevels";

const UserStake7 = () => {
  const [auth, setAuth] = useAuth({});
  const [loading, setLoading] = useState(false);
  const [loadText, setLoadText] = useState("");
  const [address, setAddress] = useState("");
  const [deodBalance, setDeodBalance] = useState(0);
  const [deodbuyValue, setDeodbuyValue] = useState("");
  const [totalStaked, setTotalStaked] = useState(0);
  const [oneTimeClaim, setOneTimeClaim] = useState(0);
  const [myreferrer, setMyreferrer] = useState("");
  const [ownership, setOwnership] = useState("");
  const [rewardPoolAmount, setRewardPoolAmount] = useState("");
  const [todaysRewardforNefi, setTodaysRewardforNefi] = useState("");
  const [totalStakedToken, setTotalStakedToken] = useState("");
  const [owner, setOwner] = useState("");
  const [availablePrincipal, setAvailablePrincipal] = useState("");
  const [availableReward, setAvailableReward] = useState("");
  const [totalReferralEarning, setTotalReferralEarning] = useState("");
  const [accRewardPerShare, setAccRewardPerShare] = useState("");
  const [totalNefiAiBought, setTotalNefiAiBought] = useState("");
  const [stakes, setStakes] = useState([]);
  const [timerLeft, setTimerLeft] = useState(0);
  const [isActive, setIsActive] = useState(false);
  const [totalAllStaked, setTotalAllStaked] = useState(0);
  const [totalAllUsdValue, setTotalAllUsdValue] = useState(0);
  const [isApproved, setIsApproved] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [activeLockTab, setActiveLockTab] = useState("noLock");
  const [stakingPeriod, setStakingPeriod] = useState("90");
  const [stakeDetails, setStakeDetails] = useState({
    stake1: 0,
    stakeA: 0,
    stake2: 0,
    stake3: 0,
    stake4: 0,
    stake5: 0,
    stake6: 0,
    stakeNv1: 0
  });

  // Network configuration
  const networkData = {
    bsc: {
      chainId: "0x38",
      chainName: "BNB Smart Chain Mainnet",
      nativeCurrency: { name: "BNB", symbol: "BNB", decimals: 18 },
      rpcUrls: ["https://bsc-dataseed.binance.org/"],
      blockExplorerUrls: ["https://bscscan.com"],
    },
  };

  const switchNetworks = async (networkName) => {
    const network = networkData[networkName];
    try {
      await window.ethereum.request({
        method: "wallet_switchEthereumChain",
        params: [{ chainId: network.chainId }],
      });
    } catch (switchError) {
      if (switchError.code === 4902) {
        try {
          await window.ethereum.request({
            method: "wallet_addEthereumChain",
            params: [network],
          });
        } catch (addError) {
          console.log(addError);
        }
      }
    }
  };

  const userLeveData = getUserLevel(totalAllStaked);

  const loadData = async () => {
    try {
      if (window?.ethereum) {
        await window.ethereum.request({
          method: "eth_requestAccounts",
        });
        const provider = new ethers.providers.Web3Provider(window.ethereum);
        await switchNetworks("bsc");
        const signer = provider.getSigner();
        const currentaccount = await signer.getAddress();
        const lowerAddress = currentaccount.toLowerCase();
        setAddress(lowerAddress);

        const contract = new ethers.Contract(stake6, stake6ABI, signer);
        const referrer = await contract.referral(lowerAddress);
        setMyreferrer(referrer);
        const ownerAddress = await contract.owner();
        setOwner(ownerAddress);
      }
    } catch (error) {
      console.log("loadData error", error);
    }
  };

  const getNefi3data = async () => {
    setLoading(true);
    setLoadText("Loading...");
    try {
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const signer = provider.getSigner();
      const currentaccount = await signer.getAddress();

      const tokenContract = new ethers.Contract(bnbDeod, bnbDeodABI, signer);
      const stakingContract = new ethers.Contract(stake6, stake6ABI, signer);
      const otcContract = new ethers.Contract(oneTimeClaimed, oneTimeClaimedABI, signer);

      const otclaimable = await otcContract.pendingClaim(currentaccount);
      setOneTimeClaim(+ethers.utils.formatEther(otclaimable));

      const principal = await stakingContract.availablePrincipal(currentaccount);
      const reward = await stakingContract.availableReward(currentaccount);
      const dailyPool = await stakingContract.dailyPool();
      const totalRefEarned = await stakingContract.totalReferralEarned(currentaccount);
      const totalStakedVal = await stakingContract.totalStaked();
      const rewardPerShare = await stakingContract.accRewardPerShare();

      setAccRewardPerShare(ethers.utils.formatEther(rewardPerShare));
      const balanceOfStaking = await tokenContract.balanceOf(stake6);
      const balanceOfUser = await tokenContract.balanceOf(currentaccount);

      setDeodBalance(ethers.utils.formatEther(balanceOfUser));
      setRewardPoolAmount(
        (+ethers.utils.formatEther(balanceOfStaking)).toFixed() -
        (+ethers.utils.formatEther(totalStakedVal)).toFixed()
      );
      setTodaysRewardforNefi(dailyPool);
      setTotalStaked(ethers.utils.formatEther(totalStakedVal));
      setAvailablePrincipal(principal);
      setAvailableReward(reward);
      setTotalReferralEarning(totalRefEarned);

      const stakeResults = [];
      let index = 0;
      while (true) {
        try {
          const res = await stakingContract.stakes(currentaccount, index);
          stakeResults.push(res);
          index++;
        } catch (err) {
          break;
        }
      }
      setStakes(stakeResults);

      if (stakeResults.length > 0) {
        const total = stakeResults.reduce((acc, row) => {
          return acc + +ethers.utils.formatEther(row[0]);
        }, 0);
        setTotalStakedToken(total);
        setTotalNefiAiBought(total);
      }
    } catch (error) {
      console.warn(error);
    }
    setLoading(false);
  };

  const [allAssets, setAllAssets] = useState({ deodPriceInUsdt: 0 });

  const fetchAllStakeData = async () => {
    try {
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const signer = provider.getSigner();
      const currentaccount = await signer.getAddress();
      const lowerAddress = currentaccount.toLowerCase();
      // Individual Contracts
      const contract2 = new ethers.Contract(StakeAddressTwo, StakeAbiTwo, provider);
      const contract3 = new ethers.Contract(StakeAddressThree, StakeAbiThree, provider);
      const contract4 = new ethers.Contract(StakeAddressFour, StakeAbiFour, provider);
      const contract5 = new ethers.Contract(stake5BSC, stake5BSCABI, provider);
      const contract1 = new ethers.Contract(stake1, stake1ABI, provider);
      const contractA = new ethers.Contract(stakeAContractAddress, stakeAContractABI, provider);
      const contractNv1 = new ethers.Contract(stakeNv1ContractAddress, stakeNv1ContractABI, provider);

      // Fetch totals
      let s1 = 0, sA = 0, s2 = 0, s3 = 0, s4 = 0, s5 = 0, sNv1 = 0;

      try { s1 = await contract1.userTotalAllotment(lowerAddress); } catch (e) { console.log("s1 error", e); }
      try { sA = await contractA.userTotalAllotment(lowerAddress); } catch (e) { console.log("sA error", e); }
      try { sNv1 = await contractNv1.userTotalAllotment(lowerAddress); } catch (e) { console.log("sNv1 error", e); }
      try { s2 = await contract2.userTotalTokenStakedV2(lowerAddress); } catch (e) { console.log("s2 error", e); }
      try { s3 = await contract3.userTotalTokenStakedV3(lowerAddress); } catch (e) { console.log("s3 error", e); }
      try { s4 = await contract4.userTotalTokenStakedV4(lowerAddress); } catch (e) { console.log("s4 error", e); }
      try { s5 = await contract5.userTotalTokenStakedV5(lowerAddress); } catch (e) { console.log("s5 error", e); }

      const val1 = +ethers.utils.formatEther(s1 || 0);
      const valA = +ethers.utils.formatEther(sA || 0);
      const val2 = +ethers.utils.formatEther(s2 || 0);
      const val3 = +ethers.utils.formatEther(s3 || 0);
      const val4 = +ethers.utils.formatEther(s4 || 0);
      const val5 = +ethers.utils.formatEther(s5 || 0);
      const valNv1 = +ethers.utils.formatEther(sNv1 || 0);

      setStakeDetails(prev => ({
        ...prev,
        stake1: val1,
        stakeA: valA,
        stake2: val2,
        stake3: val3,
        stake4: val4,
        stake5: val5,
        stakeNv1: valNv1
      }));

      // Price fetch
      const Paraswap = `https://backend.decentrawood.com/commonAPI/getDeodPrice`;
      const getParaswapData = await axios.get(Paraswap);
      let deodPriceInUsdt = 0;
      if (getParaswapData.status === 200) {
        let finalUSDTPrice = getParaswapData?.data?.data?.priceRoute?.destAmount;
        deodPriceInUsdt = (finalUSDTPrice / 10 ** 18);
      }

      setAllAssets({ deodPriceInUsdt });
    } catch (error) {
      console.log("fetchAllStakeData error", error);
    }
  };

  useEffect(() => {
    let interval;
    const restorePendingTx = async () => {
      const savedAmount = localStorage.getItem("stake_amount");
      const isStakeApproved = localStorage.getItem("isStakeApproved");

      if (savedAmount) {
        setDeodbuyValue(savedAmount);
      }

      if (isStakeApproved === "true" && address && window?.ethereum) {
        const check = async () => {
          try {
            const provider = new ethers.providers.Web3Provider(window.ethereum);
            const tokenContract = new ethers.Contract(bnbDeod, bnbDeodABI, provider);
            const allowance = await tokenContract.allowance(address, stake6);
            const targetAmount = parseFloat(savedAmount || "0");
            const parsedTarget = ethers.utils.parseEther(targetAmount.toString());

            if (allowance.gte(parsedTarget) && parsedTarget.gt(0)) {
              setIsApproved(true);
              setShowConfirmModal(true);
              setLoading(false);
              setLoadText("");
              localStorage.removeItem("isStakeApproved");
              localStorage.removeItem("stake_loading");
              if (interval) clearInterval(interval);
            }
          } catch (e) {
            console.warn("restorePendingTx polling error", e);
          }
        };
        await check();
        interval = setInterval(check, 3000);
      }
    };
    restorePendingTx();
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [address]);

  useEffect(() => {
    const checkAllowanceState = async () => {
      if (!address || !window?.ethereum) return;
      try {
        const provider = new ethers.providers.Web3Provider(window.ethereum);
        const tokenContract = new ethers.Contract(bnbDeod, bnbDeodABI, provider);
        const allowance = await tokenContract.allowance(address, stake6);

        const currentAmount = deodbuyValue ? parseFloat(deodbuyValue.toString()) : 0;
        const parsedAmount = ethers.utils.parseEther(currentAmount.toString());

        console.log("allowance", allowance.toString());
        console.log("parsedAmount", parsedAmount.toString())

        if (allowance.gte(parsedAmount) && parsedAmount.gt(0)) {
          setIsApproved(true);
        } else {
          setIsApproved(false);
        }
      } catch (error) {
        console.warn("checkAllowanceState error", error);
        setIsApproved(false);
      }
    };
    checkAllowanceState();
  }, [address, deodbuyValue]);

  // Helper to re-calculate totals whenever s6 or details change
  useEffect(() => {
    const s6 = totalStakedToken || 0;
    const total = (stakeDetails.stake1 || 0) + (stakeDetails.stakeA || 0) + (stakeDetails.stake2 || 0) + (stakeDetails.stake3 || 0) + (stakeDetails.stake4 || 0) + (stakeDetails.stake5 || 0) + (stakeDetails.stakeNv1 || 0) + (+s6);
    setTotalAllStaked(total);

    const price = allAssets?.deodPriceInUsdt || 0;
    if (price > 0) {
      setTotalAllUsdValue((total / price).toFixed(2));
    }
  }, [stakeDetails, totalStakedToken, allAssets]);

  useEffect(() => {
    const init = async () => {
      await loadData();
      await getNefi3data();
      await fetchAllStakeData();
    };
    init();
  }, []);

  useEffect(() => {
    let timer;
    if (isActive && timerLeft > 0) {
      timer = setInterval(() => {
        setTimerLeft((prev) => prev - 1);
      }, 1000);
    } else if (timerLeft === 0) {
      clearInterval(timer);
      setIsActive(false);
    }
    return () => clearInterval(timer);
  }, [isActive, timerLeft]);

  useEffect(() => {

    // RESTORE LOADER AFTER METAMASK MOBILE REDIRECT
    const loading = localStorage.getItem("stake_loading");

    if (loading === "true") {

      setLoading(true);

      setLoadText("Transaction Processing...");
    }

    // HANDLE APP RETURN FROM METAMASK
    const handleVisibility = () => {

      if (document.visibilityState === "visible") {
        console.log("Returned from MetaMask");
      }
    };

    document.addEventListener(
      "visibilitychange",
      handleVisibility
    );

    return () => {
      document.removeEventListener(
        "visibilitychange",
        handleVisibility
      );
    };

  }, []);

  const getFriendlyErrorMessage = (error) => {
    if (error?.code === "ACTION_REJECTED") return "Transaction rejected in wallet.";
    if (error?.code === "INSUFFICIENT_FUNDS") return "Insufficient BNB to pay for gas.";
    const msg = `${error?.reason || error?.data?.message || error?.message || ""}`.toLowerCase();
    if (msg.includes("insufficient") || msg.includes("0xe450d38c")) {
      return "Insufficient DEOD balance for this transaction.";
    }
    if (error?.code === "UNPREDICTABLE_GAS_LIMIT") {
      return "Transaction would fail. Please check your DEOD balance and try again.";
    }
    return error?.reason || error?.message || "Transaction failed. Please try again.";
  };

  const handleApprove = async () => {
    try {
      if (+deodbuyValue >= 1000) {
        if (+deodbuyValue > +deodBalance) {
          toast.error(`Insufficient DEOD balance. You have ${(+deodBalance).toFixed(2)} DEOD.`);
          return;
        }
        setLoading(true);
        setLoadText("Transaction Processing");

        // Save transaction state before redirecting to MetaMask mobile
        localStorage.setItem("stake_amount", deodbuyValue.toString());
        localStorage.setItem("isStakeApproved", "true");

        const provider = new ethers.providers.Web3Provider(window.ethereum);
        const signer = provider.getSigner();

        const tokenContract = new ethers.Contract(bnbDeod, bnbDeodABI, signer);

        const approveTx = await tokenContract.approve(
          stake6,
          ethers.utils.parseEther(deodbuyValue.toString())
        );
        await approveTx.wait();
        toast.success("Transaction Approved successfully!");
        setIsApproved(true);
        setShowConfirmModal(true);
        localStorage.removeItem("isStakeApproved"); // successfully completed in-session, clear it
      } else {
        toast.error("Please enter correct Amount . Amount should be more than 1000 ");
      }
    } catch (error) {
      console.log(error);
      toast.error(getFriendlyErrorMessage(error));
      localStorage.removeItem("isStakeApproved");
      localStorage.removeItem("stake_amount");
    }
    setLoadText("");
    setLoading(false);
  };


  const handleStake = async () => {
    try {
      setLoading(true);
      setLoadText("Transaction Processing");
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const signer = provider.getSigner();
      const currentaccount = await signer.getAddress();
      const stakingContract = new ethers.Contract(stake6, stake6ABI, signer);
      const tokenContract = new ethers.Contract(bnbDeod, bnbDeodABI, signer);

      const stakeAmount = ethers.utils.parseEther(deodbuyValue.toString());
      const currentBalance = await tokenContract.balanceOf(currentaccount);
      if (currentBalance.lt(stakeAmount)) {
        toast.error(`Insufficient DEOD balance. You have ${(+ethers.utils.formatEther(currentBalance)).toFixed(2)} DEOD.`);
        setLoadText("");
        setLoading(false);
        return;
      }

      const buyTx = await stakingContract.stake(stakeAmount);
      const buyRcpt = await buyTx.wait();

      if (buyRcpt.status === 1) {
        toast.success("Transaction Successful");
        setDeodbuyValue(0);
        await getNefi3data();
        localStorage.removeItem("isStakeApproved");
        localStorage.removeItem("stake_amount");
      }
    } catch (error) {
      console.log(error);
      toast.error(getFriendlyErrorMessage(error));
    }
    setLoadText("");
    setLoading(false);
  }

  const handleclaimPurchasedTokens = async () => {
    if (+ethers.utils.formatEther(availableReward) === 0) {
      return toast.error("No tokens available to Claim");
    }
    setLoading(true);
    try {
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const signer = provider.getSigner();
      const stakingContract = new ethers.Contract(stake6, stake6ABI, signer);
      const trx = await stakingContract.claimReward();
      await trx.wait();
      toast.success("Claim Successful");
      await getNefi3data();
    } catch (error) {
      console.log(error);
      toast.error("Error while claiming tokens");
    }
    setLoading(false);
  };

  const handleclaimPrincipal = async () => {
    if (+ethers.utils.formatEther(availablePrincipal) === 0) {
      return toast.error("No Tokens Available for Unstaking");
    }
    setLoading(true);
    try {
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const signer = provider.getSigner();
      const stakingContract = new ethers.Contract(stake6, stake6ABI, signer);
      const trx = await stakingContract.claimPrincipal();
      await trx.wait();
      toast.success("Unstake Successful");
      await getNefi3data();
    } catch (error) {
      console.log(error);
      toast.error("Error while Unstaking tokens");
    }
    setLoading(false);
  };

  const handleOTC = async () => {
    try {
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const signer = provider.getSigner();
      const contract = new ethers.Contract(oneTimeClaimed, oneTimeClaimedABI, signer);
      const trx = await contract.claim();
      await trx.wait();
      toast.success("Claim Successful");
      await getNefi3data();
    } catch (error) {
      toast.error(error.message);
    }
  };

  const handleownershipTransfer = async () => {
    try {
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const signer = provider.getSigner();
      const stakingContract = new ethers.Contract(stake6, stake6ABI, signer);
      const tx = await stakingContract.transferOwnership(ownership);
      await tx.wait();
      toast.success("Ownership transfer Successful");
    } catch (error) {
      toast.error(error.message);
    }
  };

  const handleEmergencyWithdrawn = async () => {
    try {
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const signer = provider.getSigner();
      const stakingContract = new ethers.Contract(stake6, stake6ABI, signer);
      const tx = await stakingContract.startFirstCycle();
      await tx.wait();
      toast.success("Start Cycle Successful");
    } catch (error) {
      toast.error(error.message);
    }
  };

  const start_and_end = (addr) => {
    if (addr) {
      return addr.substr(0, 10) + "...." + addr.substr(addr.length - 10, addr.length);
    }
    return addr;
  };

  const handleCopy = () => {
    let text = `https://stake.decentrawood.com/?referral=${address}`;
    navigator.clipboard.writeText(text);
    toast.success("Referral Link Copied");
  };

  const handleCopyy = (str) => {
    navigator.clipboard.writeText(str);
    toast.success("Text Copied");
  };

  const handleUnitChangeBuy = (e) => {
    const value = e.target.value;
    if (value !== "" && +value < 0) return;
    setDeodbuyValue(value);
  };

  const handleButtonClick = async () => {
    if (!(+deodbuyValue >= 10)) {
      toast.error("Please enter correct Amount . Amount should be more than 1000 ");
      return;
    }
    if (+deodbuyValue > +deodBalance) {
      toast.error(`Insufficient DEOD balance. You have ${(+deodBalance).toFixed(2)} DEOD.`);
      return;
    }
    if (isApproved) {
      setShowConfirmModal(true);
    } else {
      await handleApprove();
    }
  };

  const handleMaxClick = () => {
    setDeodbuyValue((+deodBalance).toFixed(2));
  };

  const lockPlans = [
    { key: "noLock", label: "No Lock", rate: "10%" },
    { key: "1m", label: "1 Month", rate: "15%" },
    { key: "3m", label: "3 Months", rate: "20%" },
    { key: "6m", label: "6 Months", rate: "25%" },
    { key: "1y", label: "1 Year", rate: "30%" },
  ];

  const stakingPeriodOptions = [
    { value: "0", label: "No Lock" },
    { value: "30", label: "30 Days (1 Month)" },
    { value: "90", label: "90 Days (3 Months)" },
    { value: "180", label: "180 Days (6 Months)" },
    { value: "365", label: "365 Days (1 Year)" },
  ];

  const getStakeStatus = (stakeRow) => {
    const maturityTimestamp = (+stakeRow[1] + 1095 * 86400) * 1000;
    if (stakeRow[2]) return "CLAIMED";
    if (Date.now() >= maturityTimestamp) return "MATURED";
    return "LOCKED";
  };

  return (
    <UserPageSection content="content">
      {loading && <Loading loading={loading} text={loadText} />}
      <h1 className="text-white f-bold" style={{}}>Welcome back <span style={{ color: "#e87722ff", textTransform: "capitalize", fontWeight: "bold", }}>{userLeveData?.name ? `${userLeveData?.name}` : ''}</span> <img style={{ width: "auto", height: "40px" }} src={userLeveData?.image} alt={userLeveData?.name} /></h1>
      {/* {+accRewardPerShare !== 0 && <div
        style={{
          backgroundColor: "#00000054",
          overflow: "hidden",
          whiteSpace: "nowrap",
          // position: "fixed",
          bottom: 0,
          width: "100%",
          zIndex: 1000,
        }}
      >
        <motion.div
          className="d-inline-block py-2"
          style={{ whiteSpace: "nowrap" }}
          animate={{ x: ["0%", "-100%"] }}
          transition={{
            repeat: Infinity,
            ease: "linear",
            duration: 40,
          }}
        >
          <div className="d-inline-block text-white px-4">
            <span className="me-5">Accumulated Reward per Staked DEOD : {(+accRewardPerShare).toFixed(2)} </span>
          </div>

          <div className="d-inline-block text-white px-4">
            <span className="me-5">Accumulated Reward per Staked DEOD : {(+accRewardPerShare).toFixed(2)} </span>
          </div>
        </motion.div>
      </div>} */}
      <div className="dashboard-main-content">
        {/* Referral Link Box */}
        {/* <div className="referral-box">
          <p style={{ fontWeight: 600 }}>Referral Link:</p>
          <span className="ref-link-text">
            https://stake.decentrawood.com/?referral={address}
          </span>
          <button className="claim-btn-outline" style={{ marginTop: 0, padding: "6px 16px", fontSize: "12px" }} onClick={handleCopy}>
            <i className="fa-solid fa-copy" style={{ marginRight: "6px" }}></i>
            Copy
          </button>
        </div> */}

        {/* Top Statistics Grid */}
        <div className="dashboard-cards-grid">
          {/* My Staked Token */}
          <div className="dashboard-card">
            <div className="dashboard-card-header">
              <span className="dashboard-card-title">My Staked Token</span>
              <div className="card-custom-icon">
                <img src={proofOfStakeImg} alt="staked" style={{ width: "70px", height: "50px" }} />
              </div>
            </div>
            <div className="dashboard-card-value">{totalStakedToken ? (+totalStakedToken).toFixed(2) : 0}</div>
            <div className="dashboard-card-subtitle">DEOD</div>
          </div>

          {/* Staking Reward */}
          <div className="dashboard-card">
            <div className="dashboard-card-header">
              <span className="dashboard-card-title">Staking Reward</span>
              <div className="card-custom-icon">
                <img src={drawalImg} alt="reward" style={{ width: "70px", height: "50px" }} />
              </div>
            </div>
            <div className="dashboard-card-value">
              {availableReward ? (+ethers.utils.formatEther(availableReward) * 0.8).toFixed(2) : 0}
            </div>
            <div className="dashboard-card-subtitle">Claimable DEOD</div>
            <button className="claim-btn" onClick={handleclaimPurchasedTokens} style={{ marginTop: "12px" }}>
              Claim Reward
            </button>
          </div>

          {/* Global Stats - Large Card */}
          <div className="dashboard-card card-large">
            <div className="dashboard-card-header">
              <span className="dashboard-card-title">Global Pool Stats</span>
              <div className="dashboard-card-icon card-icon-blue">
                <img src={tokenwallet} alt="wallet" style={{ width: "50px", height: "50px" }} />
              </div>
            </div>
            <div className="dashboard-card-value">
              {totalStaked ? (+totalStaked).toFixed(2) : 0}
            </div>
            <div className="dashboard-card-subtitle">Total DEOD Staked Globally</div>

            <div className="card-stats-row">
              <div className="card-stat-item">
                <div className="card-stat-label">Total Pool Amount</div>
                <div className="card-stat-value" style={{ color: "#f5841f" }}>
                  {rewardPoolAmount ? (+rewardPoolAmount).toFixed(2) : 0} DEOD
                </div>
              </div>
              <div className="card-stat-item">
                <div className="card-stat-label">Today's Reward</div>
                <div className="card-stat-value" style={{ color: "#f5841f" }}>
                  {todaysRewardforNefi ? (+ethers.utils.formatEther(todaysRewardforNefi)).toFixed(2) : 0} DEOD
                </div>
              </div>
            </div>
          </div>

          {/* Referral Reward */}
          <div className="dashboard-card">
            <div className="dashboard-card-header">
              <span className="dashboard-card-title">Referral Reward</span>
              <div className="card-custom-icon">
                <i className="bi bi-people-fill" style={{ color: "#f5841f" }}></i>
              </div>
            </div>
            <div className="dashboard-card-value">
              {totalReferralEarning ? (+ethers.utils.formatEther(totalReferralEarning)).toFixed(2) : 0}
            </div>
            <div className="dashboard-card-subtitle">Total Referral Earnings</div>
          </div>

          {/* Unstaking Card */}
          <div className="dashboard-card">
            <div className="dashboard-card-header">
              <span className="dashboard-card-title">Available for Unstaking</span>
              <div className="card-custom-icon">
                <img src={totalwithdrawnImg} alt="unstake" style={{ width: "70px", height: "50px" }} />
              </div>
            </div>
            <div className="dashboard-card-value">
              {availablePrincipal ? (+ethers.utils.formatEther(availablePrincipal)).toFixed(2) : 0}
            </div>
            <div className="dashboard-card-subtitle">Principal Amount</div>
            <button className="claim-btn" onClick={handleclaimPrincipal} style={{ marginTop: "12px" }}>
              Unstake
            </button>
          </div>
        </div>

        {/* Claim & Stake Sections Grid */}
        <div className="dashboard-cards-row-2">
          {/* Claim */}
          <div className="dashboard-card">
            <div className="dashboard-card-header">
              <span className="dashboard-card-title">CLAIM</span>
              <div className="card-custom-icon">
                <i className="bi bi-lock-fill" style={{ color: "#f5841f" }}></i>
              </div>
            </div>

            <div className="d-flex" style={{ gap: "8px", overflowX: "auto", paddingBottom: "8px", marginBottom: "16px" }}>
              {lockPlans.map((plan) => (
                <button
                  key={plan.key}
                  onClick={() => setActiveLockTab(plan.key)}
                  style={{
                    flex: "0 0 auto",
                    padding: "8px 14px",
                    borderRadius: "10px",
                    border: activeLockTab === plan.key ? "1px solid #f5841f" : "1px solid rgba(255,255,255,0.08)",
                    background: activeLockTab === plan.key ? "rgba(245,132,31,0.12)" : "rgba(255,255,255,0.03)",
                    color: activeLockTab === plan.key ? "#f5841f" : "rgba(255,255,255,0.6)",
                    fontSize: "12px",
                    fontWeight: 600,
                    cursor: "pointer",
                    textAlign: "center",
                    lineHeight: 1.4,
                  }}
                >
                  {plan.label}<br />
                  <span style={{ fontSize: "11px" }}>{plan.rate}</span>
                </button>
              ))}
            </div>

            <div style={{ maxHeight: "420px", overflowY: "auto", paddingRight: "4px" }}>
              {activeLockTab !== "noLock" && (
                <p style={{ color: "rgba(255,255,255,0.4)", fontSize: "13px", textAlign: "center", padding: "20px 0" }}>
                  No stakes in this plan yet.
                </p>
              )}
              {activeLockTab === "noLock" && stakes.length === 0 && (
                <p style={{ color: "rgba(255,255,255,0.4)", fontSize: "13px", textAlign: "center", padding: "20px 0" }}>
                  You have no stakes yet.
                </p>
              )}
              {activeLockTab === "noLock" && stakes.map((row, idx) => {
                const status = getStakeStatus(row);
                const allocated = new Date(+row[1] * 1000).toLocaleDateString();
                const maturity = new Date((+row[1] + 1095 * 86400) * 1000).toLocaleDateString();
                const statusColors = {
                  MATURED: { bg: "rgba(16,185,129,0.12)", color: "#10b981" },
                  LOCKED: { bg: "rgba(255,255,255,0.08)", color: "rgba(255,255,255,0.6)" },
                  CLAIMED: { bg: "rgba(255,255,255,0.05)", color: "rgba(255,255,255,0.35)" },
                };
                return (
                  <div key={idx} style={{ background: "rgba(255,255,255,0.03)", border: "1px solid rgba(255,255,255,0.06)", borderRadius: "12px", padding: "14px", marginBottom: "12px" }}>
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <span style={{ fontSize: "12px", color: "rgba(255,255,255,0.4)" }}>
                        #{idx + 1} <span style={{ color: "#fff", fontWeight: 700, fontSize: "14px", marginLeft: "6px" }}>{(+ethers.utils.formatEther(row[0])).toFixed(2)} DEOD</span>
                      </span>
                      <span style={{ fontSize: "10px", fontWeight: 700, padding: "3px 10px", borderRadius: "20px", background: statusColors[status].bg, color: statusColors[status].color }}>
                        {status}
                      </span>
                    </div>
                    <div className="row g-2 mb-2">
                      <div className="col-6">
                        <p style={{ fontSize: "10px", color: "rgba(255,255,255,0.35)", marginBottom: "2px", textTransform: "uppercase" }}>Allocated</p>
                        <p style={{ fontSize: "12px", color: "#fff", marginBottom: 0 }}>{allocated}</p>
                      </div>
                      <div className="col-6">
                        <p style={{ fontSize: "10px", color: "rgba(255,255,255,0.35)", marginBottom: "2px", textTransform: "uppercase" }}>Maturity</p>
                        <p style={{ fontSize: "12px", color: "#f5841f", fontWeight: 600, marginBottom: 0 }}>{maturity}</p>
                      </div>
                    </div>
                    <div className="row g-2 mb-3">
                      <div className="col-6">
                        <p style={{ fontSize: "10px", color: "rgba(255,255,255,0.35)", marginBottom: "2px", textTransform: "uppercase" }}>Plan Pool</p>
                        <p style={{ fontSize: "12px", color: "#fff", marginBottom: 0 }}>No Lock</p>
                      </div>
                      <div className="col-6">
                        <p style={{ fontSize: "10px", color: "rgba(255,255,255,0.35)", marginBottom: "2px", textTransform: "uppercase" }}>Tx Hash</p>
                        <p style={{ fontSize: "12px", color: "rgba(255,255,255,0.4)", marginBottom: 0 }}>—</p>
                      </div>
                    </div>
                    <button
                      className="claim-btn-outline"
                      onClick={handleclaimPrincipal}
                      disabled={status !== "MATURED"}
                      style={{ width: "100%", fontWeight: "700", opacity: status !== "MATURED" ? 0.4 : 1, cursor: status !== "MATURED" ? "not-allowed" : "pointer" }}
                    >
                      CLAIM TOKENS
                    </button>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Stake Form */}
          <div className="dashboard-card">
            <div className="dashboard-card-header">
              <span className="dashboard-card-title">
                <span style={{ display: "inline-block", width: "8px", height: "8px", borderRadius: "50%", background: "#f5841f", marginRight: "8px" }}></span>
                STAKE DEOD
              </span>
              <span style={{ fontSize: "11px", color: "#f5841f", background: "rgba(245,132,31,0.1)", padding: "6px 12px", borderRadius: "20px", fontWeight: 600 }}>
                Available: {(+deodBalance).toFixed(2)} DEOD
              </span>
            </div>

            <div className="d-flex justify-content-between align-items-center mb-2" style={{ marginTop: "20px" }}>
              <label style={{ fontSize: "11px", color: "rgba(255,255,255,0.4)", textTransform: "uppercase" }}>Stake Amount</label>
              <span style={{ fontSize: "11px", color: "rgba(255,255,255,0.4)" }}>Min: 1,000</span>
            </div>

            <div style={{ position: "relative", marginBottom: "16px" }}>
              <input
                type="number"
                min="0"
                placeholder="0.00"
                className="app-form__input"
                value={deodbuyValue}
                onChange={handleUnitChangeBuy}
                style={{ background: "rgba(0,0,0,0.2)", height: "45px" }}
              />
              <button
                onClick={handleMaxClick}
                style={{ position: "absolute", right: "8px", top: "50%", transform: "translateY(-50%)", fontSize: "11px", fontWeight: 700, color: "#f5841f", background: "rgba(245,132,31,0.12)", border: "1px solid rgba(245,132,31,0.3)", borderRadius: "8px", padding: "5px 10px", cursor: "pointer" }}
              >
                MAX
              </button>
            </div>

            <div className="mb-3">
              <label style={{ fontSize: "11px", color: "rgba(255,255,255,0.4)", display: "block", marginBottom: "4px", textTransform: "uppercase" }}>Staking Period</label>
              <select
                className="app-form__input"
                value={stakingPeriod}
                onChange={(e) => setStakingPeriod(e.target.value)}
                style={{ background: "rgba(0,0,0,0.2)", color: "#fff", height: "45px" }}
              >
                {stakingPeriodOptions.map((opt) => (
                  <option key={opt.value} value={opt.value} style={{ background: "#1a1a1a" }}>{opt.label}</option>
                ))}
              </select>
            </div>

            <button className="claim-btn-outline" onClick={handleButtonClick} style={{ width: "100%", fontWeight: "700", marginTop: "8px" }}>
              {isApproved ? "STAKE NOW" : "APPROVE & STAKE"}
            </button>
          </div>
        </div>

        {/* Conditional Cards (One Time Claim / Admin) */}
        <div className="mb-4">
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px" }}>
            {oneTimeClaim !== 0 && (
              <div className="dashboard-card" style={{ marginBottom: "20px" }}>
                <div className="dashboard-card-header">
                  <span className="dashboard-card-title">One Time Claim</span>
                  <div className="card-custom-icon">
                    <i className="bi bi-gift-fill" style={{ color: "#f5841f" }}></i>
                  </div>
                </div>
                <div className="dashboard-card-value">{(+oneTimeClaim).toFixed(2)}</div>
                <div className="dashboard-card-subtitle">Claimable Allocation</div>
                <button className="claim-btn" onClick={handleOTC} style={{ width: "100%" }}>
                  CLAIM NOW
                </button>
              </div>
            )}

            {(address.toLowerCase() === owner.toLowerCase() ||
              address.toLowerCase() === "0x7f967ec284cE3E3E3503C19dB74dc697aEa4c0F2".toLowerCase()) && (
                <div className="dashboard-card" style={{ marginBottom: "20px" }}>
                  <div className="dashboard-card-header">
                    <span className="dashboard-card-title">Ownership Transfer</span>
                    <div className="dashboard-card-icon card-icon-purple">
                      <i className="bi bi-shield-lock-fill"></i>
                    </div>
                  </div>
                  <input
                    type="text"
                    placeholder="New Owner Address"
                    className="app-form__input"
                    value={ownership}
                    onChange={(e) => setOwnership(e.target.value)}
                    style={{ marginTop: "12px" }}
                  />
                  <button className="claim-btn" onClick={handleownershipTransfer} style={{ width: "100%" }}>
                    Transfer Ownership
                  </button>
                </div>
              )}

            {(address.toLowerCase() === owner.toLowerCase() ||
              address.toLowerCase() === "0x7f967ec284cE3E3E3503C19dB74dc697aEa4c0F2".toLowerCase()) && (
                <div className="dashboard-card">
                  <div className="dashboard-card-header">
                    <span className="dashboard-card-title">Start Cycle (Owner Only)</span>
                    <div className="card-custom-icon">
                      <i className="bi bi-play-circle-fill"></i>
                    </div>
                  </div>
                  <button className="claim-btn" onClick={handleEmergencyWithdrawn} style={{ width: "100%" }}>
                    START FIRST CYCLE
                  </button>
                </div>
              )}
          </div>
        </div>

        {/* Staking History Table */}
        {stakes.length !== 0 && (
          <div className="dashboard-table-wrapper">
            <div className="p-3" style={{ borderBottom: "1px solid rgba(255,255,255,0.05)" }}>
              <h5 className="text-white mb-0">STAKING HISTORY</h5>
            </div>
            <table className="dashboard-table">
              <thead>
                <tr>
                  <th>No.</th>
                  <th>Amount (DEOD)</th>
                  <th>Start Date</th>
                  <th>End Date</th>
                </tr>
              </thead>
              <tbody>
                {stakes.map((value, key) => (
                  <tr key={key}>
                    <td>{key + 1}</td>
                    <td>{(+ethers.utils.formatEther(value[0])).toFixed(2)}</td>
                    <td>{new Date(+value[1] * 1000).toLocaleDateString()}</td>
                    <td>{new Date((+value[1] + 1095 * 86400) * 1000).toLocaleDateString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* Confirmation Modal */}
      <AnimatePresence>
        {showConfirmModal && (
          <motion.div
            className="staking-modal-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setShowConfirmModal(false)}
          >
            <motion.div
              className="staking-modal-card"
              initial={{ scale: 0.9, y: 20, opacity: 0 }}
              animate={{ scale: 1, y: 0, opacity: 1 }}
              exit={{ scale: 0.9, y: 20, opacity: 0 }}
              transition={{ type: "spring", duration: 0.3 }}
              onClick={(e) => e.stopPropagation()}
            >
              <div className="staking-modal-header">
                <h3 className="staking-modal-title">
                  {isApproved ? "Submit Staking Deposit" : "Confirm Token Approval"}
                </h3>
              </div>
              <div className="staking-modal-body">
                {isApproved ? (
                  <>
                    <p>
                      You are about to deposit and stake your tokens in the smart contract. This action will lock your tokens for the staking period.
                    </p>
                    <div className="staking-detail-box">
                      <div className="staking-detail-row">
                        <span className="staking-detail-label">Staking Amount:</span>
                        <span className="staking-detail-value">{deodbuyValue} DEOD</span>
                      </div>
                      <div className="staking-detail-row">
                        <span className="staking-detail-label">Staking Period:</span>
                        <span className="staking-detail-value">1095 Days</span>
                      </div>
                      <div className="staking-detail-row">
                        <span className="staking-detail-label">Yield Rate:</span>
                        <span className="staking-detail-value">High APR</span>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <p>
                      Before you can stake, you must authorize the staking smart contract to access your DEOD tokens. This is a one-time transaction.
                    </p>
                    <div className="staking-detail-box">
                      <div className="staking-detail-row">
                        <span className="staking-detail-label">Approval Amount:</span>
                        <span className="staking-detail-value">{deodbuyValue} DEOD</span>
                      </div>
                      <div className="staking-detail-row">
                        <span className="staking-detail-label">Spender Address:</span>
                        <span className="staking-detail-value" style={{ wordBreak: "break-all" }}>{stake6}</span>
                      </div>
                    </div>
                  </>
                )}
              </div>
              <div className="staking-modal-actions">
                <button
                  className="staking-modal-btn staking-modal-btn-cancel"
                  onClick={() => setShowConfirmModal(false)}
                >
                  CANCEL
                </button>
                <button
                  className="staking-modal-btn staking-modal-btn-confirm"
                  onClick={async () => {
                    setShowConfirmModal(false);
                    if (isApproved) {
                      await handleStake();
                    } else {
                      await handleApprove();
                    }
                  }}
                >
                  {isApproved ? "SUBMIT" : "APPROVE"}
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </UserPageSection>
  );
};

export default UserStake7;
